import React, { useState } from "react";
import { Icon } from "../../../../shared/Icon/Icon";
import { BookingsSettingsModal } from "./BookingsSettingsModal";
import { CustomerSettingsVariables } from "../../InsightsCard/Insights/Insights";
import { Role } from "../../../../../api/grpc/account/account";

interface Props {
  handleDeskSimultaneous: (values: CustomerSettingsVariables) => void;
  loading: boolean;
  disableDeskSimultaneous?: boolean;
  deskBookingDisabledForRoles?: Role[];
  deskBookingEnabled?: boolean;
  roomBookingDisabledForRoles?: Role[];
  roomBookingEnabled?: boolean;
  error?: Error;
}

export const BookingsSettings = ({
  loading,
  error,
  handleDeskSimultaneous,
  disableDeskSimultaneous,
  deskBookingDisabledForRoles,
  deskBookingEnabled,
  roomBookingDisabledForRoles,
  roomBookingEnabled,
}: Props) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <div
        className="flex-a-center cursor-pointer"
        onClick={() => setIsOpen(true)}
      >
        <Icon icon="bookings-icon" />
        <h3>Bookings settings</h3>
      </div>

      {isOpen && (
        <BookingsSettingsModal
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          loading={loading}
          error={error}
          handleDeskSimultaneous={handleDeskSimultaneous}
          disableDeskSimultaneous={disableDeskSimultaneous}
          deskBookingDisabledForRoles={deskBookingDisabledForRoles}
          deskBookingEnabled={deskBookingEnabled}
          roomBookingDisabledForRoles={roomBookingDisabledForRoles}
          roomBookingEnabled={roomBookingEnabled}
        />
      )}
    </>
  );
};
